import { useEffect, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../ui/colors";
import TableSheetLogs from "../../time-sheet/component/time-sheet-logs/components/TableSheetLogs";
import { useTimeSheetsQuery } from "../../time-sheet/hooks/useTImeSheetsQuery";
import { useTimeSheetFilters } from "../../time-sheet/hooks/useTImeSheetFilters";
import CalendarTimeSheet from "../../time-sheet/component/CalendarTimeSheet";
import CardInfoWorkforce from "../../time-sheet/component/time-sheet-logs/components/CardInfoWorkforce";
import { Assignment, History } from "@mui/icons-material";
import { workRecordStatusPrefix } from "../../time-sheet/component/time-sheet-logs/workRecordStatusFilter";

export const WorkforceJobsDetails = ({ workforce }) => {
  const { setSelectedWorker, setDateRange, queryFilters, clearAllFilters, page, pageSize, setPage, setPageSize, workStatus, setWorkStatus } =
    useTimeSheetFilters();
  const [taskPeriodLabel, setTaskPeriodLabel] = useState("ALL TASKS");
  const taskLabel = taskPeriodLabel.replace(/^ALL/, workRecordStatusPrefix(workStatus));

  useEffect(() => {
    if (workforce) {
      setSelectedWorker(workforce);
    }
  }, [workforce, setSelectedWorker]);

  const { data: timeSheetsResponse, isLoading } = useTimeSheetsQuery(queryFilters);

  const filterKey = useMemo(() => {
    return `workforce-detail-${workforce?.uid}-${queryFilters.day ?? ""}-${queryFilters.range?.start ?? ""}-${queryFilters.range?.end ?? ""}-${workStatus}`;
  }, [workforce?.uid, queryFilters.day, queryFilters.range?.start, queryFilters.range?.end, workStatus]);
  const workforceLabel = `${workforce?.firstName ?? ""} ${workforce?.lastName ?? ""} - ${workforce?.workforceRole ?? workforce?.type ?? ""}`.trim();
  return (
    <Box sx={{ background: "var(--fx-surface-sunken, #F8FAFC)", p: 2, borderRadius: 4 }}>
      <Box display="flex" alignItems="center" gap={2} mb={3}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            bgcolor: colors.orange[50],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: `1px solid ${colors.orange[200]}`,
          }}
        >
          <History sx={{ fontSize: 24, color: colors.orange.base }} />
        </Box>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, color: colors.gray[900] }}>
            Worker Activity
          </Typography>
          <Typography variant="body2" sx={{ color: colors.gray[500], mt: 0.5 }}>
            {workforceLabel}
          </Typography>
        </Box>
      </Box>
      <Box display="flex" gap={2} alignItems="flex-start">
        <TableSheetLogs
          key={filterKey}
          isGlobal={false}
          timeSheets={timeSheetsResponse?.data ?? []}
          isLoading={isLoading}
          onSelectWorker={() => {}}
          onClearFilters={clearAllFilters}
          pagination={{
            page,
            pageSize,
            setPage,
            setPageSize,
            total: timeSheetsResponse?.totalEvents ?? 0,
          }}
          tasksSummary={{
            count: timeSheetsResponse?.totalEvents ?? 0,
            label: taskLabel,
          }}
          workStatus={workStatus}
          onWorkStatusChange={setWorkStatus}
        />

        <Box sx={{ position: "sticky", top: 20 }}>
          <CalendarTimeSheet onFilter={setDateRange} onPeriodChange={setTaskPeriodLabel} />
        </Box>
      </Box>
    </Box>
  );
};
